// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';
import { StatusComponent } from './table-select-filter-components';
import { Link, Box } from '@cloudscape-design/components';
import { createTableSortLabelFn } from '../../i18n-strings';

const rawColumns = [
  {
    id: 'standard',
    header: 'Standard',
    cell: item => item.indicator.standard.title,
    sortingField: 'standard',
  },
  {
    id: 'indicator',
    header: 'Indicator',
    // cell: item => <Link href={`/indicator-submission/${item.id}`}>{item.indicator.name}</Link>,
    cell: item => item.indicator.name,
    sortingField: 'indicator',
  },
  {
    id: 'created',
    header: 'Created Date',
    cell: item => item.created,
    sortingField: 'created',
  },
  {
    id: 'agent_status',
    header: 'AI Status',
    cell: item => <StatusComponent status={item.agent_status} />,
    sortingField: 'agent_status',
  },
  // {
  //   id: 'reviewer_status',
  //   header: 'Reviewer Status',
  //   cell: item => <StatusComponent status={item.reviewer_status} />,
  //   sortingField: 'reviewer_status',
  // },
  {
    id: 'text',
    header: 'AI Notes',
    cell: item => item.text,
    sortingField: 'text',
  }
];

export const COLUMN_DEFINITIONS = rawColumns.map(column => ({ ...column, ariaLabel: createTableSortLabelFn(column) }));

export const SEARCHABLE_COLUMNS = ['standard', 'indicator', 'created', 'agent_status', 'reviewer_status', 'text'];

export const CONTENT_DISPLAY_OPTIONS = [
  { id: 'standard', label: 'Standard', alwaysVisible: true },
  { id: 'indicator', label: 'Indicator', alwaysVisible: true },
  { id: 'created', label: 'Created Date', alwaysVisible: true },
  { id: 'agent_status', label: 'AI Status', alwaysVisible: true },
  // { id: 'reviewer_status', label: 'Reviewer Status', alwaysVisible: true },
  { id: 'text', label: 'AI Notes', alwaysVisible: true }
];

export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: '10 Indicators' },
  { value: 30, label: '30 Indicators' },
  { value: 50, label: '50 Indicators' }
];